import { Link } from "react-router-dom";
import { CONFIG, RESEARCH_QUESTIONS } from "../../data/config";

const colHeading = { fontSize: 12, fontWeight: 600, letterSpacing: 1.6, textTransform: "uppercase", color: "#fff", marginBottom: 16 };
const footLink = { color: "var(--on-navy)", textDecoration: "none", fontSize: 15, lineHeight: "160%" };

export const Footer = () => (
  <footer style={{ background: "var(--navy-900)" }} data-testid="site-footer">
    <div className="container-site section">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <p style={colHeading}>Navigate</p>
          <ul className="m-0 p-0 flex flex-col gap-2" style={{ listStyle: "none" }}>
            {[
              ["Research", "/research"], ["Projects", "/projects"], ["Publications", "/publications"],
              ["Teaching", "/teaching"], ["Lab", "/lab"], ["About", "/"], ["Contact", "/contact"],
            ].map(([label, to]) => (
              <li key={to}><Link to={to} style={footLink} className="hover:underline" data-testid={`footer-link-${label.toLowerCase()}`}>{label}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <p style={colHeading}>Research threads</p>
          <ul className="m-0 p-0 flex flex-col gap-2" style={{ listStyle: "none" }}>
            {RESEARCH_QUESTIONS.map((q) => (
              <li key={q.number}><Link to="/research" style={footLink} className="hover:underline">{q.shortForm}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <p style={colHeading}>Elsewhere</p>
          <ul className="m-0 p-0 flex flex-col gap-2" style={{ listStyle: "none" }}>
            <li><a href={CONFIG.scholarUrl} target="_blank" rel="noopener noreferrer" style={footLink} className="hover:underline" data-testid="footer-scholar">Google Scholar</a></li>
            <li><a href={CONFIG.linkedinUrl} target="_blank" rel="noopener noreferrer" style={footLink} className="hover:underline" data-testid="footer-linkedin">LinkedIn</a></li>
            <li><a href={CONFIG.youtubeUrl} target="_blank" rel="noopener noreferrer" style={footLink} className="hover:underline" data-testid="footer-youtube">YouTube</a></li>
            <li><a href="https://www.gyan-dhara.com" target="_blank" rel="noopener noreferrer" style={footLink} className="hover:underline" data-testid="footer-gyan-dhara">Gyan Dhara</a></li>
            <li><a href="https://www.madvr.in" target="_blank" rel="noopener noreferrer" style={footLink} className="hover:underline" data-testid="footer-madvr">MadVR Solutions</a></li>
          </ul>
        </div>
        <div>
          <p style={colHeading}>Get in touch</p>
          <p className="m-0 mb-2"><a href={`mailto:${CONFIG.emailOfficial}`} style={footLink} className="hover:underline">{CONFIG.emailOfficial}</a></p>
          <p className="m-0 mb-2" style={{ ...footLink }}>{CONFIG.phone}</p>
          <p className="m-0" style={{ ...footLink, fontSize: 13 }}>{CONFIG.address}</p>
        </div>
      </div>
    </div>
    <div style={{ borderTop: "1px solid rgba(199,210,228,0.2)" }}>
      <div className="container-site flex flex-col sm:flex-row justify-between gap-2 py-5">
        <p className="m-0" style={{ color: "var(--on-navy)", fontSize: 13 }}>© 2026 Keyur Sorathia, PhD</p>
        <p className="m-0" style={{ color: "var(--on-navy)", fontSize: 13 }}>Last updated {CONFIG.lastUpdated}</p>
      </div>
    </div>
  </footer>
);
